import React, { Component, Suspense } from 'react';
import Icon from 'utils/components/icon';
import Selector from '../../../../common/custom-selector';
import { DAILY, HOURLY, WEEKLY } from '../../../models/resolution';
import {
  CUSTOM,
  LAST_SEVEN_DAYS,
  LAST_THIRTY_DAYS,
  TODAY,
  YESTERDAY
} from '../../../models/period';
import { LazyDatePicker } from 'app/scripts/components/common/LazyDatePicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);


function isInTooltip(node) {
  var dateNode = document.querySelector('.date-picker');
  var selectorNode = document.querySelector('.custom-selector');
  return (dateNode && dateNode.contains(node)) || (selectorNode && selectorNode.contains(node));
}

class DatesSelector extends Component {
  constructor(props, context) {
    super(props, context);

    const fromDay = dayjs(props.analytics.get('from_day')).local()
    const toDay = dayjs(props.analytics.get('to_day')).local()
    const fromDayObj = fromDay?.toDate() || new Date();
    const toDayObj = toDay?.toDate() || new Date();

    this.state = {
      period: LAST_SEVEN_DAYS,
      fromDay,
      toDay,
      fromDayObj,
      toDayObj,
      isableApply: true
    };
  }

  componentDidMount() {
    window.addEventListener('click', this.onWindowClicked.bind(this));
  }

  componentWillUnMount() {
    window.removeEventListener('click', this.onWindowClicked.bind(this));
  }

  onWindowClicked(event) {
    var tergetNode = null;
    if (event.target && event.target.className && typeof event.target.className === 'string') {
      tergetNode = document.querySelector(`.${event.target.className}`);
    }

    if (tergetNode && !isInTooltip(tergetNode) && this.refs.selector) {
      this.refs.selector.hide();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    var fromDay = this.props.analytics.get('from_day');
    var newFromDay = nextProps.analytics.get('from_day');
    var toDay = this.props.analytics.get('to_day');
    var newToDay = nextProps.analytics.get('to_day');
    if (fromDay !== newFromDay || toDay !== newToDay) {
      fromDay = dayjs(newFromDay).utc();
      toDay = dayjs(newToDay).utc();
      const fromDayObj = new Date(newFromDay);
      const toDayObj = new Date(newToDay);
      this.setState({ fromDay, toDay, fromDayObj, toDayObj });
    }
  }

  onPeriodChange(value) {
    this.setState({ period: value });
  }

  onApply() {
    var { spotId, analytics } = this.props;
    var { fromDay, toDay } = this.state;
    var device = analytics.device;

    if (this.refs.selector) {
      this.refs.selector.hide();
    }

    const diffMonths = dayjs(toDay).diff(dayjs(fromDay), 'month');
    var resolution = diffMonths >= 6 ? WEEKLY : DAILY;

    this.onPeriodChange(CUSTOM);
    let params = {
      spotId,
      device,
      resolution,
      period: CUSTOM,
      fromDay: dayjs(fromDay).utc().unix(),
      toDay: dayjs(toDay).utc().unix()
    };

    this.props.dateChange(params);
  }

  onChange(value) {
    var { spotId, analytics } = this.props;
    const { period } = this.state;
    var device = analytics.device;
    var toDay = dayjs().utc();
    var fromDay = dayjs().utc();
    var resolution = DAILY;

    if (this.refs.selector) {
      this.refs.selector.hide();
    }

    if (value === period) {
      return;
    }

    this.onPeriodChange(value);

    let fromDayFinal;
    let toDayFinal = toDay;
    switch (value) {
      case TODAY:
        fromDayFinal = fromDay.startOf('day');
        resolution = HOURLY;
        break;
      case YESTERDAY:
        fromDayFinal = fromDay.subtract(1, 'day').startOf('day');
        toDayFinal = toDay.subtract(1, 'day').endOf('day');
        resolution = HOURLY;
        break;
      case LAST_SEVEN_DAYS:
        fromDayFinal = fromDay.subtract(7, 'day');
        break;
      case LAST_THIRTY_DAYS:
        fromDayFinal = fromDay.subtract(30, 'day');
        break;
    }

    let params = {
      spotId,
      device,
      resolution,
      period: value,
      fromDay: fromDayFinal.unix(),
      toDay: toDayFinal.unix()
    };
    this.props.dateChange(params);
  }

  handleFromChange(fromDay) {
    const fromDayMoment = dayjs(fromDay).startOf('day');

    if (!fromDayMoment.isValid()) {
      console.error('Invalid date:', fromDay);
      return;
    }

    if (fromDayMoment.isAfter(this.state.toDay)) {
      this.setState({...this.state, toDay: null, toDayObj: null})
    }

    this.setState({ fromDay: fromDayMoment, fromDayObj: fromDay, disableApply: false });
  }

  handleToChange(toDay) {
    const toDayMoment = dayjs(toDay).endOf('day');

    if (!toDayMoment.isValid()) {
      console.error('Invalid date:', fromDay);
      return;
    }

    this.setState({ toDay: toDayMoment, toDayObj: toDay, disableApply: false });
  }

  isChecked(period) {
    return this.state.period === period ? 'checked' : '';
  }

  render() {
    var { fromDay, toDay, disableApply, fromDayObj, toDayObj } = this.state;

    const fromDayFinalObj = fromDayObj || fromDay?.toDate();
    const toDayFinalObj = toDayObj || toDay?.toDate();
    var fromMaxDate = new Date();
    var toMaxDate = new Date();
    var toMinDate = fromDayFinalObj;

    var items = [
      {
        value: TODAY,
        element: (
          <span onClick={this.onChange.bind(this, TODAY)}>
            Today
            {this.isChecked(TODAY) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </span>
        )
      },
      {
        value: YESTERDAY,
        element: (
          <span onClick={this.onChange.bind(this, YESTERDAY)}>
            Yesterday
            {this.isChecked(YESTERDAY) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </span>
        )
      },
      {
        value: LAST_SEVEN_DAYS,
        element: (
          <span onClick={this.onChange.bind(this, LAST_SEVEN_DAYS)}>
            Last 7 days
            {this.isChecked(LAST_SEVEN_DAYS) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </span>
        )
      },
      {
        value: LAST_THIRTY_DAYS,
        element: (
          <span onClick={this.onChange.bind(this, LAST_THIRTY_DAYS)}>
            Last 30 days
            {this.isChecked(LAST_THIRTY_DAYS) ? (
              <Icon className="checked-icon" name="validation-success" />
            ) : null}
          </span>
        )
      },
      {
        value: CUSTOM,
        element: (
          <div className="custom-dates-item">
            <div className="buttons-contianer">
              <Suspense fallback={<span className="spinner" />}>
                <div className="from-container">
                  <LazyDatePicker
                    // dateFormat="dd/MM/yyyy"
                    selected={fromDayFinalObj}
                    maxDate={fromMaxDate}
                    onChange={this.handleFromChange.bind(this)}
                    fixedHeight
                  />
                </div>
                <LazyDatePicker
                  maxDate={toMaxDate}
                  minDate={toMinDate}
                  // dateFormat="dd/MM/yyyy"
                  selected={toDayFinalObj}
                  onChange={this.handleToChange.bind(this)}
                  fixedHeight
                />
              </Suspense>
            </div>
            <button
              disabled={disableApply}
              className="apply-button"
              onClick={this.onApply.bind(this)}
            >
              Apply
            </button>
          </div>
        )
      }
    ];
    var customSelected = null;
    var { period } = this.state;

    if (period === CUSTOM) {
      fromDay = dayjs(fromDay);
      toDay = dayjs(toDay);
      customSelected = (
        <div className="calendar-item">
          <Icon name="calendar" className="calendar-icon" />
          {`${dayjs(fromDayFinalObj).format('MMM DD YYYY')} - ${dayjs(toDayFinalObj).format(
            'MMM DD YYYY'
          )}`}
        </div>
      );
    }
    return (
      <div
        className="dates-selector"
        style={{
          display: 'flex'
        }}
      >
        {this.props.loading ? (
          <span
            className="spinner"
            style={{
              marginTop: '4%',
              marginRight: '10px'
            }}
          />
        ) : null}
        <Selector
          ref="selector"
          hideOnClick={false}
          items={items}
          selected={period}
          width={240}
          customSelected={customSelected}
        />
      </div>
    );
  }
}

DatesSelector.displayName = 'DatesSelector';

export default DatesSelector;
